import { render, staticRenderFns } from "./BalanceViewCard.vue?vue&type=template&id=5449e4d4&scoped=true"
import script from "./BalanceViewCard.vue?vue&type=script&lang=js"
export * from "./BalanceViewCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5449e4d4",
  null
  
)

export default component.exports